module.exports = __webpack_public_path__ + "img/img7.a818f2f4.png";